import { useCallback, useState } from 'react'
import { AxiosError, AxiosResponse } from 'axios'
import { api, ApiRoutes } from '../services/ApiService'

export const useFetchSingle = <DataType>(url: ApiRoutes) => {
    const [data, setData] = useState<DataType | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [error, setError] = useState<string | null>(null)

    type ResponseType = {
        data: DataType | null
    }

    const handleFetchData = useCallback(
        (id?: string | number) => {
            setIsLoading(true)
            setError(null)

            api.get(url, id)
                .then((response: AxiosResponse<ResponseType>) => {
                    if (response.data?.data) {
                        setData(response.data.data)
                    }
                })
                .catch((error: AxiosError) => {
                    setError(
                        '[' + error.response?.status + ']: ' + error.message
                    )
                })
                .finally(() => {
                    setIsLoading(false)
                })
        },
        [url]
    )

    return {
        data,
        setData,
        isLoading,
        error,
        fetch: handleFetchData,
    }
}
